/**
 * FallbackDialog - Dialog para alterar percentil de fallback
 *
 * Permite ao usuário ajustar o percentil usado para estimativas
 * conservadoras de audiência quando dados reais não estão disponíveis.
 */
import React from 'react';
import {
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert,
  Typography,
  CircularProgress,
  DialogContent,
  DialogActions
} from '@mui/material';
import { TuneRounded as TuneIcon } from '@mui/icons-material';
import PlatformDialog from '../../../molecules/PlatformDialog/PlatformDialog';
import PlatformDialogTitle from '../../../molecules/PlatformDialog/PlatformDialogTitle';

const FallbackDialog = ({
  open,
  onClose,
  percentile,
  onPercentileChange,
  onUpdate,
  loading
}) => {
  return (
    <PlatformDialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
    >
      <PlatformDialogTitle
        title="Percentil de Fallback"
        subtitle="Ajuste a agressividade das estimativas."
        icon={<TuneIcon />}
        onClose={onClose}
      />
      <DialogContent sx={{ pt: 3, pb: 1 }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          O percentil define a faixa de referência para estimativas conservadoras. 
          <strong> P10</strong> (10% menores) é o recomendado.
        </Typography>
        <FormControl fullWidth size="small" sx={{ mb: 2 }}>
          <InputLabel>Percentil de Cálculo</InputLabel>
          <Select
            value={percentile}
            onChange={(e) => onPercentileChange(e.target.value)}
            label="Percentil de Cálculo"
            sx={{ borderRadius: 2 }}
          >
            <MenuItem value={5}>P5 (5% menores - Muito Conservador)</MenuItem>
            <MenuItem value={10}>P10 (10% menores - Recomendado)</MenuItem>
            <MenuItem value={15}>P15 (15% menores)</MenuItem>
            <MenuItem value={20}>P20 (20% menores)</MenuItem>
            <MenuItem value={25}>P25 (25% menores - Q1)</MenuItem>
          </Select>
        </FormControl>
        <Alert severity="info" variant="outlined" sx={{ borderRadius: 2 }}>
          Quanto menor o percentil, mais conservadora será a estimativa de audiência.
        </Alert>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, gap: 1.5 }}>
        <Button onClick={onClose} sx={{ fontWeight: 600 }}>Cancelar</Button>
        <Button 
          onClick={onUpdate} 
          variant="contained" 
          disabled={loading}
          sx={{ fontWeight: 700, borderRadius: 2, px: 3 }}
        >
          {loading ? <CircularProgress size={20} color="inherit" /> : 'Atualizar Base'}
        </Button>
      </DialogActions>
    </PlatformDialog>
  );
};

export default FallbackDialog;
